import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function HealthMonitorIntervalField({ healthMonitorInterval, error, disabled }) {

    useEffect(() => {
        validationService.validateHealthMonitorInterval(healthMonitorInterval, 'healthMonitorInterval')
        return () => validationService.cleanValidation('healthMonitorInterval');
    }, [healthMonitorInterval])

    const [touched, setTouched] = useState(false);

    const onChange = (value) => modalDataService.changeHealthMonitorInterval(value)

    const stepValue = (direction) => {
        if (disabled) {
            return;
        }

        const currentValue = parseInt(healthMonitorInterval, 10);
        const safeValue = Number.isNaN(currentValue) ? 5 : currentValue;
        const nextValue = direction === "up" ? safeValue + 1 : Math.max(1, safeValue - 1);

        onChange(String(nextValue));
    }

    return (
        <div className="form-group">
            <div className="oct_form-group modal-v2-input-suffix-group">
                <label htmlFor="healthmonitorinterval">Monitor Interval <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${(error && touched) && 'border-danger'}`}
                    id="healthmonitorinterval"
                    type="number"
                    min="1"
                    value={healthMonitorInterval}
                    placeholder="5"
                    disabled={disabled}
                    onFocus={() => setTouched(true)}
                    onChange={event => onChange(event.target.value)} />
                <div className="modal-v2-stepper-controls">
                    <button
                        type="button"
                        className="modal-v2-stepper-btn modal-v2-stepper-btn-up"
                        disabled={disabled}
                        aria-label="Increase monitor interval"
                        onClick={() => stepValue("up")}
                    >
                        ▲
                    </button>
                    <button
                        type="button"
                        className="modal-v2-stepper-btn modal-v2-stepper-btn-down"
                        disabled={disabled}
                        aria-label="Decrease monitor interval"
                        onClick={() => stepValue("down")}
                    >
                        ▼
                    </button>
                </div>
                <span className="modal-v2-input-suffix">minutes</span>
                <div className="modal-v2-field-help">How often to check device status</div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("HealthMonitorIntervalField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    return {
        healthMonitorInterval: addDeviceModal.healthMonitorInterval || '',
        error: validation.healthMonitorInterval
    }
}


export default connect(mapStateToProps)(HealthMonitorIntervalField);
